import LisioDictionaryAdapter from "../../adapters/lisio-dictionary-adapter";
import { Lisio } from "../../lisio";
import { LisioBooleanParameterNames } from "@lisio/lisio-profils";

function lisioDicoApiResponseMessageHandler(this: Lisio, datas: string) {
  const formatedData = JSON.parse(datas).word;
  (
    this.adapters.get(LisioBooleanParameterNames.VOCA) as LisioDictionaryAdapter
  ).dicoModal.openModal();
  if (formatedData.length > 0) {
    (
      this.adapters.get(
        LisioBooleanParameterNames.VOCA,
      ) as LisioDictionaryAdapter
    ).dicoModal.changeContent(formatedData);
  } else {
    (
      this.adapters.get(
        LisioBooleanParameterNames.VOCA,
      ) as LisioDictionaryAdapter
    ).dicoModal.changeContent(undefined);
  }
}
export { lisioDicoApiResponseMessageHandler };
